import { Link } from 'react-router';
import { Button } from '@mui/material';

import { useAssets } from '@labradorsports/assets';
import { createGraphMetadata, useSite } from '@labradorsports/utils';

import { HelmetWrapper, InlineLoadingSpinner } from '../../shared/index.js';
import { useGetCommunityHomepageQuery } from '../../store/index.js';
import CommunityPlayList from '../community-play-list/community-play-list.js';

interface Props {
    addPlay: AnyFunction;
}

const CommunityHome: FC<Props> = ({ addPlay }) => {
    const { LogoImg, AddFrameWhiteIcon } = useAssets();
    const { Config } = useSite();
    const { data: { newPlays, popularPlays } = {}, isLoading } = useGetCommunityHomepageQuery();

    const breadcrumbs = [
        {
            name: Config.SiteConfig.SiteName,
            url: Config.SiteConfig.Url,
        },
        {
            name: 'Community Playbook',
            url: `${Config.SiteConfig.Url}/community`,
        },
    ];

    const content = isLoading ? (
        <InlineLoadingSpinner />
    ) : (
        <>
            <div className="d-flex align-items-baseline">
                <h3 className="me-2">Latest</h3>
                <Link to="/community/latest" className="button-link">
                    See More
                </Link>
            </div>
            <CommunityPlayList plays={newPlays} />
            <br />
            <div className="d-flex align-items-baseline">
                <h3 className="me-2">Popular</h3>
                <Link to="/community/popular" className="button-link">
                    See More
                </Link>
            </div>
            <CommunityPlayList plays={popularPlays} />
        </>
    );

    return (
        <div className="community-home p-3">
            <HelmetWrapper
                title="Community Playbook"
                description={`Browse animated play diagrams shared by ${Config.SiteConfig.SiteName} users and experts, and design and contribute your own plays.`}
                image={LogoImg}
            >
                <script type="application/ld+json">{createGraphMetadata(breadcrumbs)}</script>
            </HelmetWrapper>
            <div className="d-flex">
                <h2 className="flex-grow-1">Community Playbook</h2>
                <div className="flex-shrink-0">
                    <Button variant="contained" color="secondary" className="rounded-button" onClick={addPlay}>
                        <img src={AddFrameWhiteIcon} alt="Add icon" />
                        Add Plays
                    </Button>
                </div>
            </div>
            {content}
        </div>
    );
};

export default CommunityHome;
